import 'venobox/dist/venobox.min.css'
import VenoBox from 'venobox'
import { markInitialised } from '../utils/dom'

let venoboxInstance = null

export default function initVenobox() {
	const venoboxTriggers = Array.from(document.querySelectorAll('.venobox'))

	if (!venoboxTriggers.length) return null
	if (venoboxTriggers.every((link) => link.dataset.jsVenobox === 'true')) {
		return venoboxInstance
	}

	venoboxInstance?.close?.()
	venoboxInstance = new VenoBox({
		selector: '.venobox',
	})

	venoboxTriggers.forEach((link) => {
		if (!markInitialised(link, 'jsVenobox')) return

		link.addEventListener('click', () => {
			setTimeout(() => {
				const overlay = document.querySelector('.vbox-overlay')
				if (overlay) {
					overlay.setAttribute('data-lenis-prevent', '')
				}
			}, 100)
		})
	})

	return venoboxInstance
}
